import { FilterFn } from '@tanstack/react-table';
import { isAfter, isBefore, differenceInDays, isWithinInterval } from 'date-fns';

import { DateFilterValue } from '@components';

const dateFilter: FilterFn<unknown> = (row, columnId, value) => {
  const { from, to } = (value || {}) as DateFilterValue;

  const valueDate = new Date(row.getValue(columnId));
  const fromDate = new Date(from || '');
  const toDate = new Date(to || '');

  if (from && to) {
    return isWithinInterval(valueDate, {
      start: fromDate,
      end: toDate,
    });
  } else if (from) {
    return differenceInDays(valueDate, fromDate) === 0 || isAfter(valueDate, fromDate);
  } else if (to) {
    return differenceInDays(valueDate, toDate) === 0 || isBefore(valueDate, toDate);
  }

  return true;
};

export { dateFilter };
